module.exports = __webpack_public_path__ + "img/logo1.f92e7881.png";